import React from 'react';
import vinirjiLogo from '../assets/vinirji/logo1.jpeg';
import '../styles/Footer.css';

const PARTNER_LOGIN_URL = "https://vinirji.com/vendor/partner/login";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      
      {/* --- TOP SECTION: Brand, Download, Socials --- */}
      <div className="footer-top">
        <div className="footer-top-inner">
          
          {/* Logo */}
          <img src={vinirjiLogo} alt="Vinirji Logo" className="footer-logo" />

          {/* Download Text & Badges */}
          <div className="download-section">
            <span className="download-text">Download the app from</span>
            <div className="app-badges">
              <a href="YOUR_GOOGLE_PLAY_STORE_LINK" target="_blank" rel="noopener noreferrer">
                <img
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  alt="Get it on Google Play"
                  className="store-badge"
                />
              </a>
              <a href="YOUR_APPLE_APP_STORE_LINK" target="_blank" rel="noopener noreferrer">
                <img
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1311120000"
                  alt="Download on the App Store"
                  className="store-badge"
                />
              </a>
            </div>
          </div>

          {/* Social Links */}
          <div className="social-section">
            <span className="social-label">Social Links</span>
            <div className="social-icons-row">
              <a href="YOUR_LINKEDIN_LINK" target="_blank" rel="noopener noreferrer" className="social-btn">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-9h3v9zm-1.5-10.28c-.97 0-1.75-.79-1.75-1.75s.78-1.75 1.75-1.75 1.75.79 1.75 1.75-.78 1.75-1.75 1.75zm13.5 10.28h-3v-4.5c0-1.08-.02-2.47-1.5-2.47-1.5 0-1.73 1.17-1.73 2.39v4.58h-3v-9h2.89v1.23h.04c.4-.75 1.38-1.54 2.84-1.54 3.04 0 3.6 2 3.6 4.59v4.72z"/></svg>
              </a>
              <a href="YOUR_INSTAGRAM_LINK" target="_blank" rel="noopener noreferrer" className="social-btn">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.31.974.974 1.248 2.242 1.31 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.336 2.633-1.31 3.608-.974.974-2.242 1.248-3.608 1.31-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.31-.974-.974-1.248-2.242-1.31-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.336-2.633 1.31-3.608.974-.974 2.242-1.248 3.608-1.31C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.072 5.77.131 4.672.414 3.678 1.408c-.994.994-1.277 2.092-1.336 3.374C2.013 8.332 2 8.741 2 12c0 3.259.013 3.668.072 4.948.059 1.282.342 2.38 1.336 3.374.994.994 2.092 1.277 3.374 1.336C8.332 23.987 8.741 24 12 24s3.668-.013 4.948-.072c1.282-.059 2.38-.342 3.374-1.336.994-.994 1.277-2.092 1.336-3.374.059-1.28.072-1.689.072-4.948s-.013-3.668-.072-4.948c-.059-1.282-.342-2.38-1.336-3.374-.994-.994-2.092-1.277-3.374-1.336C15.668.013 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
              </a>
              <a href="YOUR_FACEBOOK_LINK" target="_blank" rel="noopener noreferrer" className="social-btn">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.326 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.408 24 22.674V1.326C24 .592 23.406 0 22.675 0"/></svg>
              </a>
              <a href="YOUR_TWITTER_LINK" target="_blank" rel="noopener noreferrer" className="social-btn">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M17.53 3H21.5l-7.19 8.21L23 21h-6.56l-5.14-6.17L5.5 21H1.5l7.64-8.73L1 3h6.68l4.7 5.64L17.53 3zm-1.09 15.5h1.81l-5.18-6.22-1.81 2.06L16.44 18.5zm-9.38-13l5.18 6.22 1.81-2.06L7.56 4.5H7.06zm2.13 13.5h-1.81l5.18-6.22 1.81 2.06L7.56 19.5zm9.38-13l-5.18 6.22-1.81-2.06L16.44 4.5h.5z"/></svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* --- MAIN LINKS SECTION --- */}
      <footer className="footer-links-wrapper">
        <div className="footer-links-grid">
          
          {/* Column 1 */}
          <div className="footer-col">
            <h4 className="footer-heading">For Business Partners</h4>

            <a
              href={PARTNER_LOGIN_URL}
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Restaurants
            </a>

            <a
              href={PARTNER_LOGIN_URL}
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Retail Stores / Groceries
            </a>

            <a
              href={PARTNER_LOGIN_URL}
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cloud Kitchen
            </a>

            <a
    href="https://play.google.com/store/apps/details?id=com.vinirji.partnerapp&pcampaignid=web_share"
    className="footer-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    Download the app
  </a>

    <img
      src="/Business Partner App_qr-code.png"
      alt="Scan to download Business Partner App"
      className="footer-qr"
    />
          </div>

          {/* Column 2 */}
          <div className="footer-col">
  <h4 className="footer-heading">For Riders / Delivery Agent</h4>

  <a
    href="https://play.google.com/store/apps/details?id=com.vinirji.riderapp&pcampaignid=web_share"
    className="footer-link"
    target="_blank"
    rel="noopener noreferrer"
  >
    Download the app
  </a>

    <img
      id="rider-app-section"
      src="/Rider App_qr-code.png"
      alt="Scan to download Rider App"
      className="footer-qr"
    />
  
</div>

          {/* Column 3 */}
          <div className="footer-col">
            <h4 className="footer-heading">Help & Support</h4>
            <span className="footer-link">
              Email: <a href="mailto:support@vinirji.com" className="footer-highlight-link">support@vinirji.com</a>
            </span>
            <span className="footer-link">
              Phone: <a href="tel:+917093313788" className="footer-highlight-link">+91 7093383463</a>
            </span>
             <a href="/privacy-policy" className="footer-link">
    Privacy Policy
  </a>
          </div>

        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          © {new Date().getFullYear()} <span className="brand-highlight">Vinirji</span>. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Footer;